import CircularProgress from '@mui/material/CircularProgress';
import { LzTColors } from '@lz/typings';

export interface LzPSpinner {
    /**
     * The size of the component.
     * If using a number, the pixel unit is assumed.
     * If using a string, you need to provide the CSS unit, e.g '3rem'.
     * @default 40
     */
    size?: number | string;

    /**
     * The color of the component.
     * @type 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
     * @default 'primary'
     */
    color?: LzTColors;
}

const LzXSpinner = (props: LzPSpinner) => {
    return <CircularProgress size={props.size || 40} color={props.color || 'primary'} />;
};

export default LzXSpinner;
